// extracted by mini-css-extract-plugin
module.exports = {"container":"WYgUNZC0Hf5yL1_wjt9A"};